package net.bothosting.docs.pages.troubleshooting

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initAn_unexpected_error_was_encountered_while_handling_this_requestPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("troubleshooting/an_unexpected_error_was_encountered_while_handling_this_request.md", FrontMatterElement.EmptyMap))
}

@Page("/troubleshooting/an-unexpected-error-was-encountered-while-handling-this-request")
@Layout(".components.layouts.DocsLayout")
@Composable
fun An_unexpected_error_was_encountered_while_handling_this_requestPage() {
    org.jetbrains.compose.web.dom.H1(attrs = { id("an-unexpected-error-was-encountered-while-handling-this-request") }) {
        org.jetbrains.compose.web.dom.Text("An unexpected error was encountered while handling this request")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("This indicates a server error while trying to process a power action (start, restart, stop), usually caused by the node which runs your server being overloaded.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The issue is on the server’s end and cannot be fixed by you. All you can do is wait patiently for the issue to resolve itself. We ")
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("cannot")
        }
        org.jetbrains.compose.web.dom.Text(" provide an ETA (estimated time of arrival) for when this will be fixed.")
    }
    com.varabyte.kobweb.silk.components.display.Callout(type = com.varabyte.kobweb.silk.components.display.CalloutType.NOTE, label = null, variant = com.varabyte.kobweb.silk.components.display.CalloutDefaults.Variant) {
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text(" Transferring your server to a different node is only possible if you are a premium user.")
        }
    }
}
